import { Link, useLocation ,useHistory} from "react-router-dom";
import { auth } from "../firebase";

const Logo = () => {
  return (
    <Link to="/about">
      <div className="text-lg w-max font-bold flex-shrink-0  truncate overflow-hidden">
        WEB GALLARY
      </div>
    </Link>
  );
};
const PersonIcon = ({ active }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-8 h-8"
      fill={active ? "#0099ff" : "#000000"}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  );
};

const StoreIcon = ({ active }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      viewBox="0 0 24 24"
      className="w-8 h-8"
      fill={active ? "#0099ff" : "#000000"}
    >
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g />
        <g>
          <path d="M21.9,8.89l-1.05-4.37c-0.22-0.9-1-1.52-1.91-1.52H5.05C4.15,3,3.36,3.63,3.15,4.52L2.1,8.89 c-0.24,1.02-0.02,2.06,0.62,2.88C2.8,11.88,2.91,11.96,3,12.06V19c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6.94 c0.09-0.09,0.2-0.18,0.28-0.28C21.92,10.96,22.15,9.91,21.9,8.89z M18.91,4.99l1.05,4.37c0.1,0.42,0.01,0.84-0.25,1.17 C19.57,10.71,19.27,11,18.77,11c-0.61,0-1.14-0.49-1.21-1.14L16.98,5L18.91,4.99z M13,5h1.96l0.54,4.52 c0.05,0.39-0.07,0.78-0.33,1.07C14.95,10.85,14.63,11,14.22,11C13.55,11,13,10.41,13,9.69V5z M8.49,9.52L9.04,5H11v4.69 C11,10.41,10.45,11,9.71,11c-0.34,0-0.65-0.15-0.89-0.41C8.57,10.3,8.45,9.91,8.49,9.52z M4.04,9.36L5.05,5h1.97L6.44,9.86 C6.36,10.51,5.84,11,5.23,11c-0.49,0-0.8-0.29-0.93-0.47C4.03,10.21,3.94,9.78,4.04,9.36z M5,19v-6.03C5.08,12.98,5.15,13,5.23,13 c0.87,0,1.66-0.36,2.24-0.95c0.6,0.6,1.4,0.95,2.31,0.95c0.87,0,1.65-0.36,2.23-0.93c0.59,0.57,1.39,0.93,2.29,0.93 c0.84,0,1.64-0.35,2.24-0.95c0.58,0.59,1.37,0.95,2.24,0.95c0.08,0,0.15-0.02,0.23-0.03V19H5z" />
        </g>
      </g>
    </svg>
  );
};

const SignOutIcon = ({onClick}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      viewBox="0 0 24 24"
      className="w-7 h-7 cursor-pointer"
      fill="#000000"
      onClick={onClick}
    >
      <g>
        <path d="M0,0h24v24H0V0z" fill="none" />
      </g>
      <g>
        <path d="M17,8l-1.41,1.41L17.17,11H9v2h8.17l-1.58,1.58L17,16l4-4L17,8z M5,5h7V3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h7v-2H5V5z" />
      </g>
    </svg>
  );
};

const MainNav = ({ uid }) => {
  const location = useLocation();
  const history = useHistory()
  return (
    <div className="w-full h-max border-b border-opacity-20 border-black py-6 flex flex-col items-center justify-between">
      <div className="flex w-full items-center justify-between">
        <Logo />
        <nav className="flex hidden sm:flex items-center gap-12"></nav>
        <nav className="flex  items-center gap-8">
          <Link to="/">
            <StoreIcon active={location.pathname === "/"} />
          </Link>
          <Link to="/user">
            <PersonIcon active={location.pathname.includes("/user")} />
          </Link>

          {uid && <SignOutIcon onClick={
            ()=>{
              auth.signOut().then(()=>{
                history.push('/sign-in')
              }).catch(err=>{
                alert(
                  "Something happened while signing you out. If this happens continuesly please contact us. Redirecting..."
                );
              })
            }
          }/>}
        </nav>
      </div>
    </div>
  );
};

export default MainNav;
